import { render, staticRenderFns } from "./intor.vue?vue&type=template&id=6a7359b6&scoped=true"
import script from "./intor.vue?vue&type=script&lang=js"
export * from "./intor.vue?vue&type=script&lang=js"
import style0 from "./intor.vue?vue&type=style&index=0&id=6a7359b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7359b6",
  null
  
)

export default component.exports